import axios from "axios"


export const isAuth = ({ getters, commit, dispatch }) => {
    return axios.post("https://prep2go-en-es-api.vercel.app/user/isAuth", { token: getters.getToken }).then(response => {
        // set auth to vuex
        commit("setAuth", response.data.isAuth)

        // send auth
        return response.data.isAuth
    })
}


// WEBPACK FOOTER //
// ./src/store/main/actions.js